import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.infra');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-infra',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.infra/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageInfraComponent implements OnInit {
    public server: any = {};
    public loadAverage: any = {};
    public cpu: any = {};
    public memory: any = {};
    public disks: any[] = [];
    public networks: any[] = [];
    public databases: any[] = [];
    public processes: any[] = [];
    public ticketSummary: any = {};
    public loading: boolean = true;
    public lastUpdated: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.server = data.server || {};
            this.loadAverage = data.load_average || {};
            this.cpu = data.cpu || {};
            this.memory = data.memory || {};
            this.disks = data.disks || [];
            this.networks = data.networks || [];
            this.databases = data.databases || [];
            this.processes = data.processes || [];
            this.ticketSummary = data.ticket_summary || {};
        }

        this.lastUpdated = new Date().toLocaleTimeString('ko-KR');
        this.loading = false;
        await this.service.render();
    }

    public formatBytes(bytes: number): string {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    public getProgressColor(percent: number): string {
        if (percent >= 90) return 'bg-red-500';
        if (percent >= 70) return 'bg-yellow-500';
        return 'bg-emerald-500';
    }

    public getProgressBgColor(percent: number): string {
        if (percent >= 90) return 'bg-red-100';
        if (percent >= 70) return 'bg-yellow-100';
        return 'bg-emerald-100';
    }

    public getDbStatusColor(status: string): string {
        if (status === 'connected') return 'bg-emerald-500';
        if (status === 'error') return 'bg-red-500';
        return 'bg-gray-400';
    }

    public getDbStatusLabel(status: string): string {
        if (status === 'connected') return '연결됨';
        if (status === 'error') return '오류';
        return '확인중';
    }

    public getLoadColor(ratio: number): string {
        if (ratio >= 1.0) return 'text-red-600';
        if (ratio >= 0.7) return 'text-yellow-600';
        return 'text-emerald-600';
    }

    public getLoadBadgeClass(ratio: number): string {
        if (ratio >= 1.0) return 'bg-red-100 text-red-700';
        if (ratio >= 0.7) return 'bg-yellow-100 text-yellow-700';
        return 'bg-emerald-100 text-emerald-700';
    }

    public getLoadLabel(ratio: number): string {
        if (ratio >= 1.0) return '과부하';
        if (ratio >= 0.7) return '주의';
        return '정상';
    }
}

export default PageInfraComponent;